import React from 'react'
function Footer() {
    return <footer>&copy;All rights reserved | Auctionsoftware.com&reg; 2021</footer>
}
export default Footer
